import { MODAL_STATUS } from '../constants';

export const setModalStatus = (status) => ({
    type: MODAL_STATUS,
    payload: { modalStatus: status },
});
